import { DialogActions, TextField } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { getItem } from "../../../../../services/inventory/itemService";
import { Table } from "react-bootstrap";
import { DateTime } from "luxon";
function SetBatchVariantValue({
  itemID = 0,
  batchVariantValueImp = [
    {
      batchID: 0,
      batchVariantID: 0,
      varName: "",
      dataType: 1,
      stringValue: "",
      numberValue: 0,
      dateValue: null,
    },
  ],
  onConfirmSave,
  onCloseDialog,
}) {
  const [batchVariantValue, setBatchVariantValue] = useState([]);

  async function getItemData(itemID) {
    const response = await getItem(itemID);
    const { data } = response.data;
    const batchVariantValueTmp = [];

    let varValueFound = false;
    for (const varValueImp of batchVariantValueImp) {
      if (varValueImp.batchVariantID === 0) {
        varValueFound = true;
        batchVariantValueTmp.push(varValueImp);
        break;
      }
    }
    if (!varValueFound) {
      batchVariantValueTmp.push({
        batchID: 0,
        batchVariantID: 0,
        varName: "Unit Price",
        dataType: 3,
        stringValue: "",
        numberValue: 0,

        dateValue: DateTime.now(),
      });
    }
    for (const variant of data.item.batchVariant) {
      varValueFound = false;
      for (const varValueImp of batchVariantValueImp) {
        if (varValueImp.batchVariantID === variant.batchVariantID) {
          varValueFound = true;
          batchVariantValueTmp.push(varValueImp);
          break;
        }
      }
      if (!varValueFound) {
        batchVariantValueTmp.push({
          batchID: 0,
          batchVariantID: variant.ID,
          varName: variant.varName,
          dataType: variant.dataType,
          stringValue: "",
          numberValue: 0,
          dateValue: DateTime.now(),
        });
      }
    }
    setBatchVariantValue(batchVariantValueTmp);
  }
  useEffect(() => {
    getItemData(itemID);
  }, [itemID]);
  return (
    <>
      <div className="card">
        <Table striped borderless hover size="sm" responsive="xl">
          <tbody>
            {batchVariantValue && batchVariantValue.length > 0
              ? batchVariantValue.map((itemBatch, indexVariant) => {
                  return (
                    <tr key={indexVariant}>
                      <th>{itemBatch.varName}</th>
                      <td>
                        {itemBatch.dataType === 1 ? (
                          <TextField
                            name="stringValue"
                            value={itemBatch.stringValue}
                            margin="none"
                            variant="outlined"
                            size="small"
                            onChange={(e) => {
                              const batchVariantTmp = [...batchVariantValue];
                              batchVariantTmp[indexVariant].stringValue =
                                e.target.value;
                              setBatchVariantValue(batchVariantTmp);
                            }}
                            fullWidth
                          />
                        ) : itemBatch.dataType === 2 ? (
                          <KeyboardDatePicker
                            autoOk
                            inputVariant="outlined"
                            variant="inline"
                            name="dateValue"
                            value={itemBatch.dateValue}
                            format="yyyy-MM-dd"
                            onChange={(date) => {
                              const batchVariantTmp = [...batchVariantValue];
                              batchVariantTmp[indexVariant].dateValue = date;
                              setBatchVariantValue(batchVariantTmp);
                            }}
                            InputProps={{ readOnly: true }}
                          />
                        ) : null}
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
      </div>
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseDialog();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
        <button
          type="button"
          className="btn btn-success btn-md btn-pill btn-bold"
          onClick={() => {
            onConfirmSave(batchVariantValue);
          }}
        >
          <i className="fas fa-save"></i>
          Save
        </button>
      </DialogActions>
    </>
  );
}

export default SetBatchVariantValue;
